import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/**
 * ★ Safety performance (SPI) — `03` §3.7. Préfixe statique pour la fiche d'un indicateur : un
 * segment statique bat toujours `:param`, et les onglets occupent la racine.
 */
export const SafetyPerformanceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--performance']}>
    <Route path='indicator/:indicatorId' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
